/* eslint-disable no-unused-expressions */
// This allows optional chaining the logger function call

import React, {useEffect, useState, useCallback} from 'react';
import { PendoAttributes } from './types';
import { useAttachPendo, usePendoFromWindow} from './hooks';
import { useAssignIfChanged } from '../../hooks/useAssignIfChanged.hook';

export type PendoTrackerProps = {
  apiKey?: string;
  logger?(...params: unknown[]): void;
} & PendoAttributes;

const PendoTracker: React.FC<PendoTrackerProps> = ({
  apiKey,
  visitor: visitorProp,
  account: accountProp,
  logger
}: PendoTrackerProps) => {
  useAttachPendo(apiKey);
  const pendo = usePendoFromWindow();
  const trackedVisitor = useAssignIfChanged(visitorProp);
  const trackedAccount = useAssignIfChanged(accountProp);
  const [initialized, setInitialized] = useState(false);

  const initialize = useCallback((visitor, account) => {
    if(!pendo) return;

    if(visitor && account) {
      pendo.initialize({visitor, account});
 
      setInitialized(true);

      logger?.('Pendo initialized with: ', { visitor, account });
    }
  }, [pendo, logger, setInitialized]);

  const identify = useCallback((visitor, account) => {
    if(!pendo) return;

    if(visitor || account) {
      pendo.identify({
        visitor,
        account
      });

      logger?.('Pendo identified with: ', { visitor, account });
    }
  }, [pendo, logger]);

  useEffect(() => {
    if(initialized) return;

    initialize(trackedVisitor, trackedVisitor);

  }, [initialize, initialized, setInitialized, trackedVisitor, trackedVisitor]);

  useEffect(() => {
    if(!initialized) return;

    identify(trackedVisitor, trackedAccount);

  }, [initialized, identify, trackedVisitor, trackedAccount]);

  return null;
};


export default PendoTracker;
